import ReactPaginate from "react-paginate";
import { useState } from "react";
import LineChart from "../../staticComps/lineChart";
import StackedPercentageBarChart from "../../staticComps/stackedPercentageBarChart";
import GetFormattedDateTime from "../../utilities/getFormattedDateTime";
import '../../assets/stylesheet/multiSelectInputType.css';


const ResponseSummaryTab = ({ lineChartData, barChartData, tableData }) => {
  const labels = lineChartData.map(item => GetFormattedDateTime(item.RespondedOn));
  const dataSetsSCE = [
    {
      label: "Response Rate (%)",
      data: lineChartData.map(item => item.ResponseRate),
    },
  ];

  const colorSCE = [{ backgroundColor: "#04559f", borderColor: "#04559f" }];
  const lable2 = barChartData.map(item => GetFormattedDateTime(item.RespondedOn));
  const chartDatainvitation = {
    labels: lable2,
    datasets: [
      {
        label: "Invitation",
        data: barChartData.map(item => item.InvitationResponsesCount),
      },
      {
        label: "Reminder",
        data: barChartData.map(item => item.ReminderResponsesCount),
      },
    ],
  };

  const colorsinvitation = ["#04559f", "#FF9100"];
  const lable3 = barChartData.map(item => GetFormattedDateTime(item.RespondedOn));
  const chartDatasms = {
    labels: lable3,
    datasets: [
      {
        label: "SMS",
        data: barChartData.map(item => item.SmsResponsesCount),
      },
      {
        label: "WhatsApp",
        data: barChartData.map(item => item.WhatsAppResponsesCount),
      },
    ],
  };

  const colorssms = ["#1E2A5E", "#179BAE", "#CD5C08"];

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handlePageSizeChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const sortedData = [...tableData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "ascending" ? 1 : -1;
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchLower)
    );
  });
  const paginatedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <>
      {/* chart area */}
      <div className="row g-2 mb-2">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-body pt-1 pb-1">
              <h4 className="page-sub-title">Trends</h4>
              <div className="card-content">
                <div style={{ height: "250px", width: "100%" }}>
                  <LineChart
                    labels={labels}
                    dataSets={dataSetsSCE}
                    colors={colorSCE}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div className="card">
            <div className="card-body pt-1 pb-1">
              <h4 className="page-sub-title">
                Responses - Invitation, Reminder
              </h4>
              <div className="card-content">
                <div style={{ height: "250px", width: "100%" }}>
                  <StackedPercentageBarChart
                    chartData={chartDatainvitation}
                    colors={colorsinvitation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div className="card">
            <div className="card-body pt-1 pb-1">
              <h4 className="page-sub-title">Responses - SMS, WhatsApp</h4>
              <div className="card-content">
                <div style={{ height: "250px", width: "100%" }}>
                  <StackedPercentageBarChart
                    chartData={chartDatasms}
                    colors={colorssms}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Responses - People Contacted, Response, SMS, Email, Invitation, Reminder */}
      <div className="row g-2 mb-2">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="d-lg-flex align-items-center">
            <h4 className="page-sub-title">
              Responses - People Contacted, Response, SMS, WhatsApp, Invitation,
              Reminder
            </h4>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-12 col-sm-6 col-md-6">
                <p className='mb-1 me-1 paginationTotalCount'>Total items: {filteredData.length}</p>

                  <div className="d-flex align-items-center">
                    <label htmlFor="page-size" className="item-per-page">
                      Items per page:
                    </label>
                    <select
                      className="form-control-sm did-floating-select h-30 w-50px px-2 me-3 mb-1"
                      id="page-size"
                      value={itemsPerPage}
                      onChange={handlePageSizeChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                    <input
                      className="form-control-sm did-floating-input form-control h-30 w-max-200px mb-1"
                      type="text"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      placeholder="Type here to search ..."
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-6">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="table-responsive custom-table custom-table-vertical-center">
                    <table className="table table-sm table-bordered mb-2">
                      <thead>
                        <tr>
                          <th onClick={() => handleSort("RespondedOn")}>
                            Response Date{" "}
                            {sortConfig.key === "RespondedOn"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-end"
                            onClick={() => handleSort("SmsCount")}
                          >
                            SMS Sent{" "}
                            {sortConfig.key === "SmsCount"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th onClick={() => handleSort("PeopleContactedCount")}>
                            People Contacted{" "}
                            {sortConfig.key === "PeopleContactedCount"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-end"
                            onClick={() => handleSort("ResponsesCount")}
                          >
                            Responses{" "}
                            {sortConfig.key === "ResponsesCount"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th onClick={() => handleSort("ResponseRate")}>
                            Response Rate{" "}
                            {sortConfig.key === "ResponseRate"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-end"
                            onClick={() => handleSort("WhatsAppCount")}
                          >
                            WhatsApp{" "}
                            {sortConfig.key === "WhatsAppCount"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-end"
                            onClick={() => handleSort("InvitationCount")}
                          >
                            Invitation{" "}
                            {sortConfig.key === "InvitationCount"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                          <th
                            className="text-end"
                            onClick={() => handleSort("ReminderCount")}
                          >
                            Reminder{" "}
                            {sortConfig.key === "ReminderCount"
                              ? sortConfig.direction === "ascending"
                                ? "↑"
                                : "↓"
                              : ""}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((item) => (
                          <tr key={item.Id}>
                            <td>{GetFormattedDateTime(item.RespondedOn)}</td>
                            <td className="text-end">{item.SmsCount}</td>
                            <td className="text-end">{item.PeopleContactedCount}</td>
                            <td className="text-end">{item.ResponsesCount}</td>
                            <td className="text-end">{item.ResponseRate}%</td>
                            <td className="text-end">{item.WhatsAppCount}</td>
                            <td className="text-end">{item.InvitationCount}</td>
                            <td className="text-end">{item.ReminderCount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResponseSummaryTab;
